import { render } from "./DneTokenPurchase.vue?vue&type=template&id=5a8abfa0&scoped=true"
import script from "./DneTokenPurchase.vue?vue&type=script&lang=js"
export * from "./DneTokenPurchase.vue?vue&type=script&lang=js"

import "./DneTokenPurchase.vue?vue&type=style&index=0&id=5a8abfa0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8abfa0"]])

export default __exports__